import React from 'react'
import { useParams } from 'react-router'
// Component
import Select from './_Select'
// Additional
import { Phase } from 'helpers/app'
import { Routing } from 'helpers/routing'
import { TeamStatSummaryContext } from 'components/TeamStatSummary/__TeamStatSummaries.context'

const TeamStatSummary: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.TeamStatSummaryParams>()

  return (
    <TeamStatSummaryContext.Provider value={{ params: params }}>
      {p.phase === 'select' && <Select />}
    </TeamStatSummaryContext.Provider>
  )
}

export default TeamStatSummary
